import { flow } from "../data/flow.data";

export default function Flow() {
  return (
    <div className="flex flex-col gap-y-10 md:gap-y-14 w-full py-8 relative">
      <h2 className="text-[1.35rem] md:text-3xl font-medium text-center">
        How to make the most out of Genie
      </h2>
      <div className="w-full flex flex-col items-center relative">
        <div className="relative w-full">
          {flow.map(({ title, img, description }, index) => (
            <div
              key={index}
              className={`relative flex flex-col md:items-center gap-x-10 w-full ${
                index % 2 === 0
                  ? "md:flex-row justify-start"
                  : "md:flex-row-reverse justify-start md:justify-end"
              } my-8`}
            >
              <h3 className="text-lg md:text-2xl text-primary font-bold block md:hidden w-[93%] ml-auto pb-1">
                {title}
              </h3>
              <div className={`w-[93%] ml-auto md:w-1/2 flex justify-start `}>
                <img
                  src={`${img}`}
                  width={1000}
                  height={1000}
                  alt={title}
                  className="w-full max-w-xl rounded-lg shadow-sm shadow-black/50 mx-auto"
                />
              </div>
              <div className="flex flex-col gap-y-1 w-[93%] ml-auto md:w-1/2 pb-6 md:pb-0 md:pl-8 ">
                <h3 className="text-lg md:text-xl text-primary font-bold hidden md:block">
                  {title}
                </h3>
                <div className="flex flex-col gap-4 pt-2 w-[92%]">
                  <p className="md:text-base">{description}</p>
                </div>
              </div>
              <div
                className={`absolute inset-y-1/2 left-0 md:left-1/2 -translate-x-1/2 bg-primary size-8 flex items-center justify-center z-10 rounded-full text-white`}
              >
                {index + 1}
              </div>
            </div>
          ))}
        </div>
        <div className="absolute md:left-1/2 left-0 md:-translate-x-1/2 h-[95%] w-[3px] bg-gradient-to-b from-transparent via-primary to-transparent brightness-75"></div>

        <img
          src="/blob-flow.svg"
          alt="alt"
          width={500}
          height={500}
          className="absolute -z-10 blur-[50px] md:blur-[100px] opacity-50 animate-spin-slow inset-1/2 w-fit md:w-1/2"
        />
      </div>
    </div>
  );
}
